import {ACCESS_TOKEN_KEY} from '@famly/vet_ts-utils_access-token';
import {getFromLocalStorage} from '@famly/stat_ts-utils_local-storage';
import {isLoginScreenPath} from 'web-app/setup/is-login-screen-path';

/**
 * Whether the visit opens on the login screen signed out, so it can render from the login screen's
 * small namespace before the 1.5 MB global catalogue. With an access token the login screen
 * redirects into the app straight away, which needs the global catalogue first.
 */
export const rendersLoginScreenFirst = (hash: string = window.location.hash): boolean => {
    const pathname = hash.replace(/^#/, '').split('?')[0];

    return !getFromLocalStorage(ACCESS_TOKEN_KEY) && isLoginScreenPath(pathname);
};
